// Utilitaires pour filtrer les props DOM valides
export const filterDOMProps = <T extends Record<string, any>>(props: T): Partial<T> => {
  const {
    jsx, // Supprimer jsx qui cause des erreurs React
    children,
    key,
    ref,
    ...validProps
  } = props;

  return validProps as Partial<T>;
};
